import { z } from "zod";
import { newPasswordSchema } from "@/shared/lib/passwordSchema";

// The confirm field is client-only (not sent to the backend) so a typo can't lock the user out.
export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, "Obligatoriskt"),
    newPassword: newPasswordSchema,
    confirmPassword: z.string().min(1, "Obligatoriskt"),
  })
  .refine((v) => v.newPassword === v.confirmPassword, {
    message: "Lösenorden matchar inte",
    path: ["confirmPassword"],
  });

export type ChangePasswordInput = z.input<typeof changePasswordSchema>;
export type ChangePasswordValues = z.output<typeof changePasswordSchema>;
